import { render } from "./SELECT_LANGUAGE.vue?vue&type=template&id=0e8f4fb7"
import script from "./SELECT_LANGUAGE.vue?vue&type=script&lang=js"
export * from "./SELECT_LANGUAGE.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__